"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Coveo = require("coveo-search-ui");
var CoveoForSitecoreBase_1 = require("./CoveoForSitecoreBase");
var Searchbox = (function (_super) {
    __extends(Searchbox, _super);
    function Searchbox(searchComponent, searchBoxPluginOptions, defaultSearchBoxPluginOptions) {
        _super.call(this, searchComponent, searchBoxPluginOptions, defaultSearchBoxPluginOptions);
        this.searchBoxOptions = _.extend({}, defaultSearchBoxPluginOptions, searchBoxPluginOptions);
    }
    Searchbox.prototype.initialize = function () {
        var _this = this;
        this.logger.log("Initializing searchbox.");
        this.initializeSearchOptions();
        if (!this.options.isInitialized) {
            this.domElement.on(Coveo.QueryEvents.buildingQuery, function (e, args) {
                var expression = _this.expressionsHelper.getSearchExpression(_this.searchBoxOptions);
                args.queryBuilder.advancedExpression.add(expression);
            });
        }
        Coveo.initSearchbox(this.element, this.searchBoxOptions.searchRedirectionUrl, this.searchBoxOptions);
        if (this.searchBoxOptions.searchRedirectionItemName) {
            var searchBoxComponent = Coveo.get(this.element, Coveo.SearchInterface);
            if (searchBoxComponent) {
                searchBoxComponent.componentOptionsModel.set("searchHub", this.searchBoxOptions.searchRedirectionItemName);
            }
        }
        this.doPostInitializationActions();
    };
    return Searchbox;
}(CoveoForSitecoreBase_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Searchbox;



//////////////////
// WEBPACK FOOTER
// ./Base/Searchbox.js
// module id = 18
// module chunks = 0